/* eslint-disable */
<template>
  <div>
    <div
      v-if="!printerFriendly"
      class="stratfilters">
      <div>
        <div class="stratline">
          <div class="label">Year</div>
          <div
            v-if="years.length === 1"
            class="dib">{{ year }}</div>
          <div
            v-else
            class="dib">
            <fieldset
              class="hideFieldset"
              style="float: left; margin-right: 5px;">
              <legend class="accessibleHide">Year</legend>
              <input
                :value="true"
                v-model="filterState.allYears"
                :id="'rb1_' + instance"
                :name="'irbYear_' + instance"
                type="radio"
              >
              <label :for="'rb1_' + instance">All available years</label>
              <input
                :value="false"
                v-model="filterState.allYears"
                :id="'rb2_' + instance"
                :name="'irbYear_' + instance"
                type="radio"
              >
              <label
                :for="'rb2_' + instance"
                class="accessibleHide"
              >Single year</label>
            </fieldset>
            <StratFilter
              :id="'islYear_' + instance"
              :items="years"
              v-model="filterState.yearId"
              :show-debug-ids="showDebugIds"
              class="dib"
              label="Year"
            />
            <div
              v-if="xAxisColumn === 'yr' && showDebugIds"
              class="dib"
            >{{ xAxisPointer }}</div>
          </div>
        </div>
        <div class="stratline">
          <div class="label">View by</div>
          <div class="dib">
            <StratFilter
              :id="'sc1_' + instance"
              :items="stratCats1"
              v-model="filterState.stratCatId1"
              :show-debug-ids="showDebugIds"
              label="View by"
              class="stratcat"
            />
          </div>
          <div
            v-if="showStrat1"
            class="dib">
            <StratFilter
              :id="'s1_' + instance"
              :items="strats1"
              v-model="filterState.stratId1"
              :show-debug-ids="showDebugIds"
              label="View by"
              class="strat"
            />
          </div>
          <div
            v-if="xAxisColumn === 's1' && showDebugIds"
            class="dib"
          >{{ xAxisPointer }}</div>
          <div
            v-if="legendColumn === 's1' && showDebugIds"
            class="dib"
          >{{ legendPointer }}</div>
        </div>
        <div
          v-if="hasLevel2"
          class="stratline">
          <div class="label">View by</div>
          <div class="dib">
            <StratFilter
              :id="'sc2_' + instance"
              :items="stratCats2"
              v-model="filterState.stratCatId2"
              :show-debug-ids="showDebugIds"
              label="View by"
              class="stratcat"
            />
          </div>
          <div class="dib">
            <StratFilter
              :id="'s2_' + instance"
              :items="strats2"
              v-model="filterState.stratId2"
              :show-debug-ids="showDebugIds"
              label="View by"
              class="strat"
            />
          </div>
          <div
            v-if="xAxisColumn === 's2' && showDebugIds"
            class="dib"
          >{{ xAxisPointer }}</div>
          <div
            v-if="legendColumn === 's2' && showDebugIds"
            class="dib"
          >{{ legendPointer }}</div>
        </div>
        <div class="stratline">
          <div class="label">Response</div>
          <div class="dib">
            <StratFilter
              :id="'rs_' + instance"
              :items="responses"
              v-model="filterState.responseId"
              :show-debug-ids="showDebugIds"
              label="Response"
              class="response"
            />
          </div>
          <div
            v-if="xAxisColumn === 'rs' && showDebugIds"
            class="dib"
          >{{ xAxisPointer }}</div>
          <div
            v-if="legendColumn === 'rs' && showDebugIds"
            class="dib"
          >{{ legendPointer }}</div>
        </div>
        <div
          v-if="showDataValueTypes"
          class="stratline">
          <div class="label">Data Type</div>
          <div class="dib">
            <StratFilter
              :id="'dvt_' + instance"
              :items="dataValueTypes"
              v-model="filterState.dataValueTypeId"
              :show-debug-ids="showDebugIds"
              label="Data Type"
            />
          </div>
        </div>
      </div>
    </div>
    <SPViewTitle
      :instance="instance"
      :filter-state="filterState"/>
    <div v-if="showDebugIds && view === 'Chart'">
      {{ chartSummary508 }}
    </div>
    <div v-if="showDebugIds && view === 'Table'">
      {{ tableSummary508 }}
    </div>
    <SPChartView
      v-if="filteredDataHasNumericDataValues && view == 'Chart'"
      :instance="instance"
      :chart-config-object="chartConfigObject"
      :filtered-data="filteredData"
      :lku="lku"/>
    <div
      v-if="!filteredDataHasNumericDataValues && view == 'Chart'"
      class="nodatamessage">
      No data to display in chart view.
    </div>
    <SPTableView
      v-if="filteredData.length > 0 && view == 'Table'"
      :instance="instance"
      :table-config-object="tableConfigObject"
      :filtered-data="filteredData" />
    <div v-if="showDebugIds==='All'">
      <div class="b">chartConfigObject:</div>
      <div>{{ chartConfigObject }} </div>
      <div v-if="showDebugIds">
        {{ filterState }}
      </div>
      <SPTempDisplayRawSPData
        :instance="instance"
        :table-data="filteredData"
        table-label="Filtered data:"/>
    </div>
    <SPPanelFootnotes
      v-if="showFootnotes"
      :filtered-data="filteredData"
      :instance="instance"
      class="pb3"/>
    <div
      v-if="!printerFriendly"
      class="buttonContainer">
      <button
        class="exportButton"
        @click="saveAsPdf"
      >Print / Save as PDF</button>
      <button
        class="exportButton"
        @click="exportCsv"
      >Export CSV</button>
    </div>
  </div>
</template>

<style scoped>
  .stratfilters {
    margin-top: .5rem;
    padding-left: .5rem;
  }
  .stratline {
    display: table;
    margin: 5px 0;
  }
  .label {
    display: table-cell;
    vertical-align: top;
    font-weight: bold;
    width: 75px;
  }
  .hideFieldset {
    border: none;
    display: inline;
    padding: 0;
  }
  .dib {
    display: inline-block;
  }
  .b {
    font-weight: bold;
  }
  .stratcat {
    width: 150px;
  }
  .strat {
    width: 150px;
    margin: 0 5px;
  }
  .response {
    max-width: 306px;
    margin-right: 5px;
  }
  .nodatamessage {
    height: 300px;
    text-align: center;
    padding-top: 140px;
    font-weight: bold;
  }
  .buttonContainer {
    margin: 0 0 5px 5px;
  }
  .exportButton {
    border-radius: 4px;
    border-color: 1px solid #ccc;
    padding: 5px 8px;
    margin: 0 3px;
    background-color: #C1DED5;
    font-family: Lato,Helvetica Neue,Helvetica,Arial,sans-serif;
  }
  .pb3 {
    padding-bottom: 1rem;
  }
</style>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import FileSaver from 'file-saver';
import Blob from 'blob';
import helper from '../../helper';
import StratFilter from '../common/StratFilter';
import SPViewTitle from './SPViewTitle';
import SPTempDisplayRawSPData from './SPTempDisplayRawSPData';
import SPChartView from './SPChartView';
import SPTableView from './SPTableView';
import SPPanelFootnotes from './SPPanelFootnotes';

const overallStratCatId = process.env.OverallStratCatId;

function addAllOption(list, boolAdd) {
  if (boolAdd) {
    list.splice(0, 0, { id: '', name: 'All' });
  }
  return list;
}

const maxAllCount = 2;

export default {
  name: 'SPStratFilters',
  components: {
    StratFilter,
    SPViewTitle,
    SPTempDisplayRawSPData,
    SPChartView,
    SPTableView,
    SPPanelFootnotes,
  },
  props: {
    instance: {
      type: Number,
      default: 0,
    },
    view: {
      type: String,
      default: 'Chart',
    },
  },
  data() {
    return {
      filterState: {
        allYears: this.$store.getters.getDefaultFromQueryStringPnlParmIfInitialPageLoad(false, this.instance, 'allYears'),
        yearId: this.$store.getters.getDefaultFromQueryStringPnlParmIfInitialPageLoad('', this.instance, 'yearId'),
        stratCatId1: this.$store.getters.getDefaultFromQueryStringPnlParmIfInitialPageLoad('', this.instance, 'stratCatId1'),
        stratId1: this.$store.getters.getDefaultFromQueryStringPnlParmIfInitialPageLoad('', this.instance, 'stratId1'),
        stratCatId2: this.$store.getters.getDefaultFromQueryStringPnlParmIfInitialPageLoad('', this.instance, 'stratCatId2'),
        stratId2: this.$store.getters.getDefaultFromQueryStringPnlParmIfInitialPageLoad('', this.instance, 'stratId2'),
        responseId: this.$store.getters.getDefaultFromQueryStringPnlParmIfInitialPageLoad('', this.instance, 'responseId'),
        dataValueTypeId: this.$store.getters.getDefaultFromQueryStringPnlParmIfInitialPageLoad('', this.instance, 'dataValueTypeId'),
      },
      interactionType: '',
    };
  },
  computed: {
    ...mapState({
      lku: state => state.lku,
      dataTypes: state => state.dataTypes,
      spData: state => state.SP.spData,
      indicators: state => state.SP.indicators,
      showFootnotes: state => state.SP.flags.showFootnotes,
      showDebugIds: state => state.flags.showDebugIds,
      GSGo: state => state.SP.GSGo,
      panels: state => state.SP.panels,
      initialPageLoad: state => state.flags.initialPageLoad,
      generatingPdf: state => state.SP.flags.generatingPdf,
      goClicked: state => state.SP.flags.goClicked,
    }),
    printerFriendly() {
      return this.$store.getters.printerFriendly;
    },
    indicatorId() {
      return this.indicators[this.instance].id;
    },
    useDoubleWidePanels() {
      return this.$store.getters['SP/useDoubleWidePanels'];
    },
    years() {
      return _(this.spData[this.indicatorId]).map('yr').uniq()
        .map(id => this.lku.Year[id])
        .orderBy('sort', 'desc')
        .value();
    },

    // computed cols to watch to set interactionType
    allYears() {
      return this.filterState.allYears;
    },
    stratCatId1() {
      return this.filterState.stratCatId1;
    },
    stratId1() {
      return this.filterState.stratId1;
    },
    stratCatId2() {
      return this.filterState.stratCatId2;
    },
    stratId2() {
      return this.filterState.stratId2;
    },
    responseId() {
      return this.filterState.responseId;
    },

    year() {
      const row = this.lku.Year[this.filterState.yearId];
      return row ? row.name : '';
    },
    yearId() {
      return this.filterState.yearId;
    },
    stratCats1() {
      const filter = {};
      if (!this.filterState.allYears) filter.yr = this.filterState.yearId;
      return _(this.spData[this.indicatorId]).filter(filter)
        .map('sc1').uniq()
        .map(id => this.lku.StratificationCategory[id])
        .orderBy('sort', 'asc')
        .value();
    },
    showStrat1() {
      return this.filterState.stratCatId1 !== overallStratCatId;
    },
    hasLevel2() {
      return !_.isUndefined(_(this.spData[this.indicatorId])
        .find(o => o.sc1 === this.filterState.stratCatId1 && o.sc2));
    },
    strats1() {
      const filter = {};
      if (!this.filterState.allYears) filter.yr = this.filterState.yearId;
      filter.sc1 = this.filterState.stratCatId1;
      const rows = _(this.spData[this.indicatorId]).filter(filter)
        .map('s1').uniq()
        .map(id => this.lku.Stratification[id])
        .orderBy('sort', 'asc')
        .value();
      return addAllOption(rows, rows.length > 1);
    },
    stratCats2() {
      if (!this.hasLevel2) return [];
      const filter = {};
      if (!this.filterState.allYears) filter.yr = this.filterState.yearId;
      filter.sc1 = this.filterState.stratCatId1;
      if (this.filterState.stratId1) filter.s1 = this.filterState.stratId1;
      const rows = _(this.spData[this.indicatorId]).filter(filter)
        .map('sc2').uniq()
        .compact() // remove undefined from array if above key is not found
        .map(id => this.lku.StratificationCategory[id])
        .orderBy('sort', 'asc')
        .value();
      const hasLevel1 = _(this.spData[this.indicatorId])
        .filter(filter).filter(o => !o.sc2).value().length > 0;
      if (hasLevel1) {
        return helper.addSelectOne(rows);
      }
      return rows;
    },
    strats2() {
      if (this.filterState.stratCatId2 === '') return [];
      const filter = {};
      if (!this.filterState.allYears) filter.yr = this.filterState.yearId;
      filter.sc1 = this.filterState.stratCatId1;
      if (this.filterState.stratId1) filter.s1 = this.filterState.stratId1;
      if (this.filterState.stratCatId2) filter.sc2 = this.filterState.stratCatId2;
      const rows = _(this.spData[this.indicatorId]).filter(filter)
        .map('s2').uniq()
        .compact() // remove undefined from array if above key is not found
        .map(id => this.lku.Stratification[id])
        .orderBy('sort', 'asc')
        .value();
      const addAll = (this.filterState.allYears ? 1 : 0)
        + (this.filterState.stratId1 === '' ? 1 : 0) < maxAllCount && rows.length > 1;
      return addAllOption(rows, addAll);
    },
    responses() {
      const filter = {};
      if (!this.filterState.allYears) filter.yr = this.filterState.yearId;
      filter.sc1 = this.filterState.stratCatId1;
      if (this.filterState.stratId1) filter.s1 = this.filterState.stratId1;
      if (this.filterState.stratCatId2) filter.sc2 = this.filterState.stratCatId2;
      if (this.filterState.stratId2) filter.s2 = this.filterState.stratId2;
      const rows = _(this.spData[this.indicatorId]).filter(filter)
        // remove level2 rows if hasLevel2 and stratCatId2 is blank
        .filter(o => (this.hasLevel2 && this.filterState.stratCatId2 === '' ? !o.s2 : true))
        .map('rs')
        .uniq()
        .map(id => this.lku.Response[id])
        .orderBy('sort', 'asc')
        .value();
      const addAll =
        (this.filterState.allYears ? 1 : 0)
        + (this.filterState.stratId1 === '' ? 1 : 0)
        + (this.filterState.stratCatId2 !== ''
        && this.filterState.stratId2 === '' ? 1 : 0) < maxAllCount
        && rows.length > 1;
      return addAllOption(rows, addAll);
    },
    dataValueTypes() {
      const filter = {};
      if (!this.filterState.allYears) filter.yr = this.filterState.yearId;
      filter.sc1 = this.filterState.stratCatId1;
      if (this.filterState.stratId1) filter.s1 = this.filterState.stratId1;
      if (this.filterState.stratCatId2) filter.sc2 = this.filterState.stratCatId2;
      if (this.filterState.stratId2) filter.s2 = this.filterState.stratId2;
      if (this.filterState.responseId) filter.rs = this.filterState.responseId;
      return _(this.spData[this.indicatorId]).filter(filter)
        // remove level2 rows if hasLevel2 and stratCatId2 is blank
        .filter(o => (this.hasLevel2 && this.filterState.stratCatId2 === '' ? !o.s2 : true))
        .map('dvt')
        .uniq()
        .map(id => this.lku.DataValueType[id])
        .orderBy('sort', 'asc')
        .value();
    },
    showDataValueTypes() {
      return this.dataValueTypes.length > 1;
    },
    dataValueTypeProps() {
      const row = this.dataTypes[this.filterState.dataValueTypeId];
      return row || {};
    },
    filteredData() {
      const filter = {};
      if (!this.filterState.allYears) filter.yr = this.filterState.yearId;
      filter.sc1 = this.filterState.stratCatId1;
      if (this.filterState.stratId1) filter.s1 = this.filterState.stratId1;
      if (this.filterState.stratCatId2) filter.sc2 = this.filterState.stratCatId2;
      if (this.filterState.stratId2) filter.s2 = this.filterState.stratId2;
      if (this.filterState.responseId) filter.rs = this.filterState.responseId;
      filter.dvt = this.filterState.dataValueTypeId;
      return _(this.spData[this.indicatorId]).filter(filter)
        // remove level2 rows if hasLevel2 and stratCatId2 is blank
        .filter(o => (this.hasLevel2 && this.filterState.stratCatId2 === '' ? !o.s2 : true))
        .value();
    },
    filteredDataYearCount() {
      return _(this.filteredData).map('yr').uniq().value().length;
    },
    filteredDataHasNumericDataValues() {
      return _(this.filteredData).filter(o => _.isNumber(o.dv)).value().length > 0;
    },
    multistrat() {
      return this.filteredData[0].multistrat;
    },
    xAxisColumn() {
      if (this.filterState.allYears) return 'yr';
      if (this.filterState.stratId1 === ''
        && this.filterState.stratCatId2 !== ''
        && this.filterState.stratId2 === '') {
        return 's1';
      }
      return 'rs';
    },
    xAxisType() {
      if (this.xAxisColumn === 'yr') return 'Year';
      if (this.xAxisColumn === 'rs') return 'Response';
      return 'Stratification';
    },
    legendColumn() {
      if (this.filterState.allYears) {
        if (this.filterState.stratId1 === '') return 's1';
        if (this.filterState.stratCatId2 !== ''
          && this.filterState.stratId2 === '') return 's2';
        return 'rs';
      }
      if (this.filterState.stratCatId2 !== ''
        && this.filterState.stratId2 === ''
      ) return 's2';
      return 's1';
    },
    legendType() {
      if (this.legendColumn === 'rs') return 'Response';
      return 'Stratification';
    },
    legendTitle() {
      if (this.filteredData.length === 0) return '';
      if (this.legendColumn === 'rs') return 'Response';
      if (this.legendColumn === 's1'
        && this.filterState.stratCatId1 === overallStratCatId) return '';
      const legendTitleColumn = this.legendColumn === 's1' ? 'sc1' : 'sc2';
      return this.lku.StratificationCategory[this.filteredData[0][legendTitleColumn]].name;
    },
    displayTrendChart() {
      return this.filterState.allYears && this.filteredDataYearCount > 2;
    },
    chartSummary508() {
      const legendCount = _(this.filteredData).map(this.legendColumn).uniq().value().length;
      if (this.displayTrendChart) {
        return `This trend chart presents ${process.env.SystemName508} data with ${legendCount} lines for ${this.legendTitle} across all available years. For an accessible view of the data, choose display table.`;
      }
      let xAxisType;
      switch (this.xAxisColumn) {
        case 'rs':
          xAxisType = 'response';
          break;
        case 's1':
          xAxisType = this.lku.StratificationCategory[this.filterState.stratCatId1].name;
          break;
        case 's2':
          xAxisType = this.lku.StratificationCategory[this.filterState.stratCatId2].name;
          break;
        case 'yr':
          xAxisType = 'year';
          break;
        default:
          throw new Error(`Unexpected xAxisColumn: ${this.xAxisColumn}`);
      }
      return `This bar chart presents ${process.env.SystemName508} data with ${legendCount} bars for ${this.legendTitle} for each ${xAxisType} on the x-axis. For an accessible view of the data, choose display table.`;
    },
    chartConfigObject() {
      return {
        xAxisColumn: this.xAxisColumn,
        xAxisType: this.xAxisType,
        legendColumn: this.legendColumn,
        legendType: this.legendType,
        legendTitleStr: this.legendTitle,
        displayTrendChart: this.displayTrendChart,
        chartDivId: `chartDiv_${this.instance}`,
        colorsArrStr: ['#FFFF99', '#FDBF6F', '#FF7F00', '#CAB2D6', '#f781bf', '#a65628', '#ff7f00', '#984ea3', '#4daf4a', '#e41a1c', '#377eb8'].reverse(),
        yAxisTitle: this.dataValueTypeProps.chartAxisLabel,
        decimalPlaces: this.dataValueTypeProps.decimalPlaces,
        confidenceIntervalLabel: this.dataValueTypeProps.confidenceIntervalLabel,
        sampleSizeLabel: this.dataValueTypeProps.sampleSizeLabel,
        dataValuePrefix: this.dataValueTypeProps.dataValuePrefix,
        dataValueSuffix: this.dataValueTypeProps.dataValueSuffix,
        chartDesc: this.chartSummary508,
        useDoubleWidePanels: this.useDoubleWidePanels,
      };
    },
    tableSummary508() {
      let headingType;
      switch (this.legendColumn) {
        case 'rs':
          headingType = 'response';
          break;
        case 's1':
          headingType = this.lku.StratificationCategory[this.filterState.stratCatId1].name;
          break;
        case 's2':
          headingType = this.lku.StratificationCategory[this.filterState.stratCatId2].name;
          break;
        default:
          throw new Error(`Unexpected legendColumn: ${this.legendColumn}`);
      }
      const headingCount = _(this.filteredData).map(this.legendColumn).uniq().value().length;
      const headingColumns = headingCount > 1 ? `${headingCount} columns` : `${headingCount} column`;
      let groupType;
      switch (this.xAxisColumn) {
        case 'yr':
          groupType = 'available year';
          break;
        case 'rs':
          groupType = 'response';
          break;
        case 's1':
          groupType = this.lku.StratificationCategory[this.filterState.stratCatId1].name;
          break;
        case 's2':
          groupType = this.lku.StratificationCategory[this.filterState.stratCatId2].name;
          break;
        default:
          throw new Error(`Unexpected xAxisColumn: ${this.xAxisColumn}`);
      }
      const dvt = this.dataTypes[this.filterState.dataValueTypeId].dataRowLabel;

      return `This table presents ${process.env.SystemName508} data by ${headingType} (as ${headingColumns}) for each ${groupType} (as row subheadings) where each row subheading has the rows ${dvt}, confidence interval, and weighted number.`;
    },
    tableConfigObject() {
      return {
        groupColumn: this.xAxisColumn,
        groupType: this.xAxisType,
        headingColumn: this.legendColumn,
        headingType: this.legendType,
        ssColumn: 'wn',
        dataRowLabel: this.dataValueTypeProps.dataRowLabel,
        ciRowLabel: this.dataValueTypeProps.confidenceIntervalLabel,
        ssRowLabel: this.dataValueTypeProps.sampleSizeLabel,
        decimalPlaces: this.dataValueTypeProps.decimalPlaces,
        tableSummary508: this.tableSummary508,
      };
    },
    xAxisPointer() {
      return '<===x-axis/group rows';
    },
    legendPointer() {
      return '<===legend/columns';
    },
    indicatorsCsv() {
      return this.$store.getters['SP/indicatorsCsv'];
    },
    filterStateViewCsv() {
      const filterStateArr = _(this.filterState).map(val => val).value();
      return `${filterStateArr.join(',')},${this.view}`;
    },
  },
  watch: {
    view() {
      this.setInteractionType('LV');
    },
    years() {
      this.setDefaultYearId();
      this.setDefaultAllYears();
    },
    allYears() {
      this.setInteractionType('LY');
    },
    yearId() {
      this.resetAllYears();
      this.setInteractionType('LY');
    },
    stratCats1() {
      // stratCats1 gets recomputed when the filter.allYears is changed
      // which causes this watch to fire.
      // If current stratCatId1 is valid, don't change to the default
      if (!_(this.stratCats1).find({ id: this.filterState.stratCatId1 })) {
        this.setDefaultStratCatId1();
      }
    },
    stratCatId1() {
      this.setInteractionType('LST');
    },
    strats1() {
      this.setDefaultStratId1();
    },
    stratId1() {
      this.setInteractionType('LST');
    },
    stratCats2() {
      this.setDefaultStratCatId2();
    },
    stratCatId2() {
      this.setInteractionType('LST');
    },
    strats2() {
      this.setDefaultStratId2();
    },
    stratId2() {
      this.setInteractionType('LST');
    },
    responses() {
      this.setDefaultResponseId();
    },
    responseId() {
      this.setInteractionType('LR');
    },
    dataValueTypes() {
      this.setDefaultDataValueTypeId();
    },
    indicatorsCsv() {
      this.setDefaultFilterState();
    },
    filterStateViewCsv() {
      // This watch is fired when the user changes a strat filter or the panel view buttons,
      // or when the panel is first loaded when not the initial page load. In this case, the
      // panel filter state will be different from the default state set when the
      // filterState data was initialized, due to setDefaultFilterState() in the created event.
      // console.log('watch for filterStateViewCsv Bef', this.instance, _.size(this.panels), this.initialPageLoad, this.goClicked);
      this.updatePanelObjectForInstanceAndClearInitialPageLoadAndReplaceUrl();
      // console.log('watch for filterStateViewCsv Aft', this.instance, _.size(this.panels), this.initialPageLoad, this.goClicked);
    },
  },
  mounted() {
    if (this.printerFriendly) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', window.print());
      } else {
        window.print();
      }
    }
  },
  created() {
    this.setDefaultFilterState();
    if (this.initialPageLoad) {
      // if panel state was set from valid qs parameters on initial page load,
      // the watch for filterStateViewCsv will not fire, since the
      // default filter state will match the initial filter state/view.
      // The following call is needed to make the panel state object match
      // the panel state, to clear the initial page load flag, and to
      // update the browser URL bar.
      this.updatePanelObjectForInstanceAndClearInitialPageLoadAndReplaceUrl();
    }
    // console.log('SPStratFilters created', this.instance, _.size(this.panels), this.initialPageLoad);
  },
  methods: {
    setDefaultYearId() {
      this.filterState.yearId = helper.defaultOrFirstId(
        this.years,
        this.filterState.yearId,
        this.initialPageLoad,
      );
    },
    setDefaultAllYears() {
      if (this.initialPageLoad) {
        if (this.years.length === 1) {
          // initial page load with only 1 year, set allYears to false
          this.filterState.allYears = false;
        }
      } else {
        // use clicked go or changed indicator selections, default to single year view
        this.filterState.allYears = false;
      }
    },
    resetAllYears() {
      if (!this.initialPageLoad) {
        this.filterState.allYears = false;
      }
    },
    setDefaultStratCatId1() {
      this.filterState.stratCatId1 = helper.defaultOrFirstId(
        this.stratCats1,
        this.filterState.stratCatId1,
        this.initialPageLoad,
      );
    },
    setDefaultStratId1() {
      this.filterState.stratId1 = helper.defaultOrFirstId(
        this.strats1,
        this.filterState.stratId1,
        this.initialPageLoad,
      );
    },
    setDefaultStratCatId2() {
      this.filterState.stratCatId2 = helper.defaultOrFirstId(
        this.stratCats2,
        this.filterState.stratCatId2,
        this.initialPageLoad,
      );
    },
    setDefaultStratId2() {
      this.filterState.stratId2 = helper.defaultOrFirstId(
        this.strats2,
        this.filterState.stratId2,
        this.initialPageLoad,
      );
    },
    setDefaultResponseId() {
      this.filterState.responseId = helper.defaultOrFirstId(
        this.responses,
        this.filterState.responseId,
        this.initialPageLoad,
      );
    },
    setDefaultDataValueTypeId() {
      this.filterState.dataValueTypeId = helper.defaultOrFirstId(
        this.dataValueTypes,
        this.filterState.dataValueTypeId,
        this.initialPageLoad,
      );
    },
    setDefaultFilterState() {
      this.setDefaultYearId();
      this.setDefaultAllYears();
      this.setDefaultStratCatId1();
      this.setDefaultStratId1();
      this.setDefaultStratCatId2();
      this.setDefaultStratId2();
      this.setDefaultResponseId();
      this.setDefaultDataValueTypeId();
    },
    setInteractionType(newInteractionType) {
      // keep current value if already set
      this.interactionType = this.interactionType ? this.interactionType : newInteractionType;
    },
    resetInteractionType() {
      this.interactionType = '';
    },
    triggerPanelInteraction(interactionType) {
      this.$store.getters['SP/triggerPanelInteraction'](this.instance, interactionType);
    },
    updatePanelObjectForInstanceAndClearInitialPageLoadAndReplaceUrl() {
      // update the panels object for this instance in the SP store
      // object rest/spread syntax https://github.com/tc39/proposal-object-rest-spread
      this.$store.commit('SP/setPanel', {
        instance: this.instance,
        panelObj: {
          view: this.view,
          ...this.filterState,
        },
      });
      if (!this.initialPageLoad && !this.goClicked) {
        this.triggerPanelInteraction(this.interactionType);
      }
      this.resetInteractionType();
      if (this.indicators.length === _.size(this.panels)) {
        // The panel object in the SP store have been updated for all panel instances
        if (this.initialPageLoad) {
          // clear initial page load after all panel instances have been processed
          this.$store.commit('setInitialPageLoad', false);
        }
        if (this.goClicked) {
          // clear goClicked after all panel instances have been processed
          this.$store.commit('SP/setGoClicked', false);
        }
        this.$store.getters['SP/setBrowserUrlBarToReflectCurrentSPState'](this.$router);
      }
    },
    saveAsPdf() {
      if (!this.generatingPdf) {
        this.$store.commit('SP/setGeneratingPdf', true);
        this.triggerPanelInteraction('LE PDF');
        const panelsObjForQS = {};
        panelsObjForQS.pnl0 = _(this.panels[this.instance]).map(val => val).value().join(',');
        const qsObj = {
          LocationId: this.GSGo.locationId,
          CategoryId: this.GSGo.categoryId,
          ShowFootnotes: this.showFootnotes,
          showMode: 'Export',
          IndicatorIds: this.indicators[this.instance].id,
          ...panelsObjForQS,
        };

        const qs = _(qsObj).map((val, key) => `${key}=${val}`).value().join('&');
        const url = `${window.location.protocol}//${window.location.host}/SP?${qs}`;
        // eslint-disable-next-line
        console.log(qs);
        window.open(url, '_blank');
        this.$store.commit('SP/setGeneratingPdf', false);

        // const singlePanelUrl = `${window.location.origin}${process.env.RouterBase}/SP?${qs}`;
        // console.log(singlePanelUrl);
        /*
        api.post('ExportToPDF', {
          exportFormat: 1, // 1: PDF, 2: PDFLandscape
          myVirtualDirectoryOnDev: process.env.MyVirtualDirectoryOnDev,
          urlToRender: `MyVirtualDirectory/SP?${qs}`,
          exportFileName: 'Export.pdf',
          conversionDelaySec: 10,
        }, {
          responseType: 'blob',
        }).then((response) => {
          FileSaver.saveAs(response.data, 'Export.pdf');
          this.$store.commit('SP/setGeneratingPdf', false);
        }).catch((err) => {
          this.$notify({
            type: 'error',
            title: 'Export error',
            text: `Export to PDF failed: ${err.response.status} ${err.response.statusText}`,
          });
          this.$store.commit('SP/setGeneratingPdf', false);
        });
        */
      }
    },
    exportCsv() {
      const csv = this.$store.getters['SP/csvExport'](this.instance, this.filteredData, this.multistrat);
      this.triggerPanelInteraction('LE EX');
      // console.log(csv);
      const blob = new Blob([csv], { type: 'text/html;charset=utf-8' });
      FileSaver.saveAs(blob, 'Export.csv');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SP/SPStratFilters.vue